import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	name
	capacity
	photo_url
	position
	kind
	available_for
	aed
	active
	
	translations {
		${FieldsTranslation}
	}
`;
